import { Skeleton } from "@/components/ui/skeleton";

// Same columns as CommunityRow: avatar, a 260px name block, the members tile (lg), themes (md), two actions.
// Keep them in step with the row, or the list jumps when it loads.
const CommunityRowSkeleton = () => (
  <div className="flex items-center gap-4 px-4 py-3 bg-card rounded-2xl border border-border/60">
    <Skeleton className="w-14 h-14 rounded-full shrink-0" />
    <div className="w-[260px] shrink-0 min-w-0 space-y-2">
      <Skeleton className="h-4 w-3/5" />
      <Skeleton className="h-3.5 w-2/5" />
    </div>
    <div className="hidden lg:flex flex-col items-center gap-1.5 min-w-[64px] pr-4 shrink-0">
      <Skeleton className="h-3.5 w-10" />
      <Skeleton className="h-2.5 w-12" />
    </div>
    <div className="hidden md:flex flex-1 min-w-0 flex-col gap-1.5 pl-6">
      <Skeleton className="h-3 w-24" />
      <div className="flex gap-1">
        <Skeleton className="h-[18px] w-16 rounded" />
        <Skeleton className="h-[18px] w-20 rounded" />
      </div>
    </div>
    <div className="ml-auto flex shrink-0 items-center gap-[20px]">
      <Skeleton className="w-7 h-7 rounded-full" />
      <Skeleton className="w-7 h-7 rounded-full" />
    </div>
  </div>
);

export default CommunityRowSkeleton;
